export default class QPaginationUtils {
  static addAriaLabels(t) {
    const buttons = document.querySelectorAll(".q-pagination .q-btn");
    if (buttons) {
      buttons.forEach((button) => {
        const ariaLabel = QPaginationUtils.setAriaForButton(button, t);
        if (ariaLabel) button.setAttribute("aria-label", ariaLabel);
      });
    }
  }

  static setAriaForButton(button, t) {
    // Page buttons
    const numSpan = button.querySelector(".q-btn__content .block");
    if (numSpan) return `${t("common.page")} ${numSpan.textContent}`;
    // Previous and next buttons
    const icon = button.querySelector(".q-btn__content .q-icon");
    if (icon) {
      const previousBtn = "keyboard_arrow_left";
      const nextBtn = "keyboard_arrow_right";
      if (icon.textContent === previousBtn) return t("common.previous_page");
      else if (icon.textContent === nextBtn) return t("common.next_page");
    }

    return null;
  }

  static setAriaCurrentForPagination(paginationRef, currentPage) {
    if (!paginationRef?.value) return;

    const prevActive = paginationRef.value.$el.querySelector(
      '[aria-current="page"]'
    );
    if (prevActive) prevActive.removeAttribute("aria-current");

    const newActive = Array.from(
      paginationRef.value.$el.querySelectorAll("button span.block")
    )
      .map((span) => span.closest("button"))
      .find((btn) => parseInt(btn.textContent, 10) === currentPage);
    if (newActive) newActive.setAttribute("aria-current", "page");
  }
}
